/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionAlert } from './ApiSanctionAlert';
import {
    ApiSanctionAlertFromJSON,
    ApiSanctionAlertFromJSONTyped,
    ApiSanctionAlertToJSON,
    ApiSanctionAlertToJSONTyped,
} from './ApiSanctionAlert';

/**
 * 
 * @export
 * @interface ApiSanctionAlerts
 */
export interface ApiSanctionAlerts {
    /**
     * 
     * @type {Array<ApiSanctionAlert>}
     * @memberof ApiSanctionAlerts
     */
    alerts: Array<ApiSanctionAlert>;
}

/**
 * Check if a given object implements the ApiSanctionAlerts interface.
 */
export function instanceOfApiSanctionAlerts(value: object): value is ApiSanctionAlerts {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function ApiSanctionAlertsFromJSON(json: any): ApiSanctionAlerts {
    return ApiSanctionAlertsFromJSONTyped(json, false);
}

export function ApiSanctionAlertsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionAlerts {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(ApiSanctionAlertFromJSON)),
    };
}

export function ApiSanctionAlertsToJSON(json: any): ApiSanctionAlerts {
    return ApiSanctionAlertsToJSONTyped(json, false);
}

export function ApiSanctionAlertsToJSONTyped(value?: ApiSanctionAlerts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(ApiSanctionAlertToJSON)),
    };
}

